/* eslint-disable no-bitwise */
const ASSESSMENT_TYPE = {
  MCQ_ASSESSMENT: 1,
  CODING_ASSESSMENT: 2,
  AI_INTERVIEW: 3,
};

export const QUESTION_TYPE = {
  MCQ: 1,
  CODING: 2,
  AITEXT: 3,
  AIVOICE: 4,
  AICODING: 5,
};

export const QUESTION_MASK_TYPE = {
  MCQ: 1,
  CODING: 2,
  AITEXT: 4,
  AIVOICE: 8,
  AICODING: 16,
};

export const AI_ANSWER_TYPE = {
  TEXT: 1,
  AUDIO: 2,
};

export const getBinaryAssessmentQType = (qtype) => ({
  mcq: (qtype & QUESTION_MASK_TYPE.MCQ) === QUESTION_MASK_TYPE.MCQ,
  coding: (qtype & QUESTION_MASK_TYPE.CODING) === QUESTION_MASK_TYPE.CODING,
  aitext: (qtype & QUESTION_MASK_TYPE.AITEXT) === QUESTION_MASK_TYPE.AITEXT,
  aivoice: (qtype & QUESTION_MASK_TYPE.AIVOICE) === QUESTION_MASK_TYPE.AIVOICE,
  aicoding:
    (qtype & QUESTION_MASK_TYPE.AICODING) === QUESTION_MASK_TYPE.AICODING,
});

export default ASSESSMENT_TYPE;
